// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"f9856c9d","918":"e523ff9a"}[chunkId] + ".chunk.js";
};